module.exports = __webpack_public_path__ + "4da653cff5ba5e650961a19b256e7f9d.svg";